var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTwoRoom = function SvgTwoRoom(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 58,
    height: 48,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#two-room_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 1.5,
    d: "M44.16 15.008V52m0-36.992h12.331m-12.331 0L36.673 1.135"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "two-room_svg__b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 8.478,
    height: 9.248,
    x: 10.248,
    y: 17.318,
    rx: 0.771
  })), /*#__PURE__*/React.createElement("rect", {
    width: 8.478,
    height: 9.248,
    x: 10.248,
    y: 17.318,
    stroke: "#000",
    strokeLinejoin: "round",
    strokeWidth: 3,
    mask: "url(#two-room_svg__b)",
    rx: 0.771
  }), /*#__PURE__*/React.createElement("mask", {
    id: "two-room_svg__c",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 8.478,
    height: 9.248,
    x: 24.121,
    y: 17.318,
    rx: 0.771
  })), /*#__PURE__*/React.createElement("rect", {
    width: 8.478,
    height: 9.248,
    x: 24.121,
    y: 17.318,
    stroke: "#000",
    strokeLinejoin: "round",
    strokeWidth: 3,
    mask: "url(#two-room_svg__c)",
    rx: 0.771
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M8.707 1.135 1 15.393V52h55.49V15.007L48.397 1.135z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "two-room_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h58v48H0z"
  })))));
};
export default SvgTwoRoom;